export const getMinAutoupdateInterval = () => {
    return 30;
};
